<script lang="ts">
  import SettingsUserDetail from "@modern/components/retailer/settings/User/Details.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/employees",
    });
  };

</script>

{#await load()}
  <Spinner />
{:then usersRes}
  <SettingsUserDetail {usersRes} userId={$params["userId"]} />
{/await}
